module.exports = "/_next/static/videos/hero-video-46c1106b5266543b24ad8492d9eacfb3.mp4";